// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"279":"component---src-pages-index-jsx","401":"component---src-pages-civic-data-api-jsx","659":"component---src-templates-legal-page-jsx"}[chunkId] || chunkId) + "-" + {"279":"08fc0281be8cd8563ddb","401":"11777839934de55729ec","522":"eedc86724d3d929b9fc9","659":"0c263af5f367aee550e1"}[chunkId] + ".js";
};